import { useCallback } from "react";
import { useQuery } from "./useQuery";
import { MOCK_ACCOUNTS } from "../pages/Accounting/Overview/overviewMockData";
import type { AccountSummary } from "../pages/Accounting/Overview/overviewTypes";
import type { QueryResult } from "./types";

/**
 * Returns the user's business bank accounts.
 *
 * Default: returns MOCK_ACCOUNTS so the populated dashboard renders.
 * URL flags for state preview on the deployed app:
 *   ?empty=1       → force the empty state (no accounts connected)
 *   ?populated=1   → force populated (same as default)
 *   ?populated=0   → force empty (legacy alias, kept so existing links work)
 *
 * When the real backend ships, replace the mock branch with
 * useQuery(["accounts"], fetchAccounts). The default becomes
 * "return whatever the user actually has connected", and the flags
 * stay in for QA until a staging seed layer replaces them.
 */
export function useAccounts(): QueryResult<AccountSummary[]> {
  const query = useQuery();
  const forceEmpty = query.get("empty") === "1" || query.get("populated") === "0";
  const data = forceEmpty ? [] : MOCK_ACCOUNTS;

  const refetch = useCallback(() => {}, []);
  return { data, loading: false, error: null, refetch };
}